import React from "react";
import { useTranslation } from "react-i18next";
import { formatBytes } from "./fileKinds";

function formatEta(seconds, t) {
  if (seconds == null) return "";
  if (seconds < 60) return t("share.upload.eta_sec", { count: Math.max(1, seconds) });
  if (seconds < 3600) return t("share.upload.eta_min", { count: Math.ceil(seconds / 60) });
  return t("share.upload.eta_hour", { hours: Math.floor(seconds / 3600), minutes: Math.ceil((seconds % 3600) / 60) });
}

/** Overall bar: "45% · 1.2 GB / 2.7 GB" and "12 MB/s · 2 min left". */
export default function OverallProgress({ uploadedBytes, totalBytes, speed, eta }) {
  const { t } = useTranslation();
  const pct = totalBytes ? Math.min(100, Math.floor((uploadedBytes / totalBytes) * 100)) : 0;

  return (
    <div className="shr-overall">
      <div className="shr-overall-row">
        <span>
          <strong style={{ color: "#111827" }}>{pct}%</strong> · {formatBytes(uploadedBytes)} / {formatBytes(totalBytes)}
        </span>
        <span>
          {speed > 0 && `${formatBytes(speed)}/s`}
          {eta != null && ` · ${formatEta(eta, t)}`}
        </span>
      </div>
      <div className="shr-progress lg"><span style={{ width: `${pct}%` }} /></div>
    </div>
  );
}
